import { ObjectHash, Theme } from '../../../types/shared'
import { IChartThemeColors, chartDarkTheme, chartLightTheme } from '../constants'
import { BE_LARGE_CHART_WITH_OVERLAYS_CHART_SETTINGS } from './be_large_chart_with_overlays'
import { BE_LARGE_CHART_WITHOUT_OVERLAYS_CHART_SETTINGS } from './be_large_chart_without_overlays'
import { BE_SMALL_CHART_WITH_OVERLAYS_CHART_SETTINGS } from './be_small_chart_with_overlays'
import { BE_SMALL_CHART_WITHOUT_OVERLAYS_CHART_SETTINGS } from './be_small_chart_without_overlays'
import { INTERACTIVE_CHART_SETTINGS } from './interactive_chart_settings'
import { ISettings } from './interfaces'

export enum CHART_FORMAT {
  INTERACTIVE = 'INTERACTIVE',
  BE_SMALL_CHART_WITHOUT_OVERLAYS = 'BE_SMALL_CHART_WITHOUT_OVERLAYS',
  BE_SMALL_CHART_WITH_OVERLAYS = 'BE_SMALL_CHART_WITH_OVERLAYS',
  BE_LARGE_CHART_WITHOUT_OVERLAYS = 'BE_LARGE_CHART_WITHOUT_OVERLAYS',
  BE_LARGE_CHART_WITH_OVERLAYS = 'BE_LARGE_CHART_WITH_OVERLAYS',
}

export const getChartSettings = ({ chartFormat, theme }: { theme: Theme; chartFormat?: CHART_FORMAT }): ISettings => {
  switch (chartFormat) {
    case CHART_FORMAT.BE_SMALL_CHART_WITHOUT_OVERLAYS:
      return BE_SMALL_CHART_WITHOUT_OVERLAYS_CHART_SETTINGS(theme)
    case CHART_FORMAT.BE_SMALL_CHART_WITH_OVERLAYS:
      return BE_SMALL_CHART_WITH_OVERLAYS_CHART_SETTINGS(theme)
    case CHART_FORMAT.BE_LARGE_CHART_WITHOUT_OVERLAYS:
      return BE_LARGE_CHART_WITHOUT_OVERLAYS_CHART_SETTINGS(theme)
    case CHART_FORMAT.BE_LARGE_CHART_WITH_OVERLAYS:
      return BE_LARGE_CHART_WITH_OVERLAYS_CHART_SETTINGS(theme)
    case CHART_FORMAT.INTERACTIVE:
    default:
      return INTERACTIVE_CHART_SETTINGS(theme)
  }
}

function normalizeHexAlpha(hexString = '') {
  const hexValue = hexString.replace('#', '')
  if (hexValue.length === 6) {
    return `${hexString}FF`
  }
  return hexString
}

export const getColorOverwrites = ({
  theme,
  colors,
}: {
  theme: Theme
  colors: ObjectHash<Partial<IChartThemeColors>, Theme>
}) => {
  const customColors = colors[theme]
  const customColorKeys = Object.keys(customColors) as Array<keyof Partial<IChartThemeColors>>
  const defaultColors = theme === Theme.light ? chartLightTheme : chartDarkTheme

  return customColorKeys.reduce((acc, wickColorKey) => {
    const isDefaultOverWritten =
      normalizeHexAlpha(customColors[wickColorKey]).toLowerCase() !==
      normalizeHexAlpha(defaultColors[wickColorKey]?.toLowerCase())

    return isDefaultOverWritten
      ? {
          ...acc,
          [wickColorKey]: customColors[wickColorKey],
        }
      : acc
  }, {})
}
